import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { IApps } from "../../../../models/master/apps";
import { IStudentApps } from "../../../../models/dashboard/studentDashboard";
import { useEffect } from "react";
import { pageBlockId, limit } from "../../../../constants/pageBlocks";
import { getApps } from "../../../../action/masters/appActionCreator";
import { connect, useDispatch } from "react-redux";
import { setApps } from "../../../../store/slices/master/appSlice";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";
import React from "react";

const StudentApps = (props: IStudentApps) => {
  const { getAllStudentApps, studentApps, snapShots } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.studentApps);

  const handleViewALL = () => {
    navigate(`${ROUTER_URL.RESOURCES}#resource-apps`);
  };

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllStudentApps(pageBlockId.studentApps, limit.eleven);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setApps([]));
    }
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Student Apps</h2>
          <a
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All"
            onClick={handleViewALL}
          >
            View All
          </a>
        </div>
        <div className="row">
          {studentApps
            ?.filter((app: IApps) => app.displayOrNot)
            .map((app: IApps) => (
              <div className="col-lg-12" key={app.id}>
                <div className="btncard icon-visibility">
                  <a href={app.url == "http://35.160.94.121:4006/" ? app.url + `?token=${localStorage.getItem("token")}&username=${localStorage.getItem("username")}` : app.url} target="_blank" rel="noopener noreferrer">
                    <img src={baseURL + app.image} alt={app.name} />
                    <h3>{app.name}</h3>
                    <span>
                      <img
                        src="/assets/images/icon/arrow-right.svg"
                        alt="Arrow icon"
                      />
                    </span>
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllStudentApps: (pageBlockId?: number, noOfItems?: number) =>
    getApps(undefined, pageBlockId, undefined,noOfItems),
};

function mapStateToProps(state: any) {
  return {
    studentApps: state.app.apps,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(StudentApps));
